import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Search } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { normalizeRegistration, useRegistrationLookup, validRegistration } from "@/hooks/useRegistrationLookup";

export const HomeRegistrationSearch = () => {
  const navigate = useNavigate();
  const [registration, setRegistration] = useState("");
  const [error, setError] = useState("");
  const { status } = useRegistrationLookup();

  const submit = event => {
    event.preventDefault();
    const normalized = normalizeRegistration(registration);
    if (!validRegistration(normalized)) {
      setError("Enter a valid UK registration, for example AB12 CDE."); return;
    }
    navigate(`/tuning-database?registration=${encodeURIComponent(normalized)}`);
  };

  return <div className="mt-8 max-w-2xl" data-testid="home-vrm-lookup">
    <p className="mb-3 font-display text-sm font-bold uppercase tracking-[0.12em] text-white" data-testid="home-vrm-heading">Find your Stage 1 gains</p>
    <form onSubmit={submit} className="flex flex-col gap-3 sm:flex-row" data-testid="home-vrm-form">
      <label htmlFor="home-vrm-registration" className="sr-only">UK registration</label>
      <div className="relative min-w-0 flex-1">
        <Search aria-hidden="true" className="absolute left-4 top-1/2 -translate-y-1/2 text-neutral-600" size={18} />
        <Input id="home-vrm-registration" value={registration} onChange={event => { setRegistration(event.target.value.toUpperCase()); setError(""); }}
          data-testid="home-vrm-input" placeholder="AB12 CDE" maxLength={12} autoComplete="off" spellCheck={false}
          className="h-14 rounded-none border-2 border-amber-300 bg-amber-50 pl-12 font-mono text-xl font-bold uppercase tracking-normal text-slate-950 shadow-none placeholder:text-slate-500 md:text-xl" />
      </div>
      <Button type="submit" disabled={!registration.trim() || !status} data-testid="home-vrm-submit"
        className="h-14 rounded-none bg-regal-amber px-7 font-display font-bold uppercase tracking-[0.1em] text-white hover:bg-amber-400">
        Check my vehicle <ArrowRight size={17} />
      </Button>
    </form>
    {error && <p role="alert" className="mt-3 text-sm font-medium text-white" data-testid="home-vrm-error">{error}</p>}
    <button type="button" onClick={() => navigate("/tuning-database#td-selector")} data-testid="home-vrm-manual"
      className="mt-3 text-sm font-semibold text-white underline decoration-white/40 underline-offset-4 transition-colors duration-200 hover:text-regal-amber">
      Or select your vehicle manually
    </button>
  </div>;
};